import { useRef, useCallback, useLayoutEffect } from 'react'
import { useMeasure } from 'react-use'

/**
 * Calculate the height of the dataset menu; update the folder height to fill the
 * remaining space.
 */
export const useFolderHeight = () => {
  const [datasetMenuRef, { height: menuHeight }] = useMeasure<HTMLDivElement>()
  const folderRef = useRef<HTMLDivElement | null>(null)

  useLayoutEffect(() => {
    if (!folderRef.current) return
    const topPos = folderRef.current.getBoundingClientRect().top
    const BOTTOM_PADDING = 30
    const windowHeight = window.innerHeight
    const folderHeight = windowHeight - topPos - BOTTOM_PADDING
    folderRef.current.style.height = `${folderHeight}px`
  }, [menuHeight])

  const getDatasetMenuRef = useCallback(() => datasetMenuRef, [datasetMenuRef])

  function setFolderRef(ref) {
    folderRef.current = ref
  }

  return {
    datasetMenuRef,
    menuHeight,
    setFolderRef,
    getDatasetMenuRef,
  }
}
